angular.module('st')
    .controller('crewardsCommunicationsController', [
        '$rootScope', '$scope', '$http', 
        function ($rootScope, $scope, $http) {
            var ctrl = this;
            $scope.feedback = '';
            $scope.processing = false;
            $scope.saveDisabled = true;

            ctrl.SetModel = function (commPreferences) {
                $scope.model = commPreferences;
            }
            
            ctrl.UpdatePreferences = function () {
                if ($scope.processing == false) {
                    $scope.processing = true;
                    $scope.feedback = 'Saving preferences...';
                    var payload = { ReceiveEmails: $scope.model.receiveEmails, ReceiveTexts: $scope.model.receiveSMS };
                    $http.post("/rpc/membership/account/communications", payload)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                $scope.feedback = '';
                                $scope.processing = false;
                                $scope.saveDisabled = true;
                            } else {
                                // vista error
                                $scope.processing = false;
                                $scope.feedback = 'Error: ' + data.data.Message;
                            }
                        }).catch(function (error) {
                            // our server error
                            $scope.processing = false;
                            $scope.feedback = 'Error occurred while trying to save settings.'
                        })
                    }
                }
            }
        ]   
    );
